module.exports = __webpack_public_path__ + "media/images/interlogix_logo-ab02d39435a6be3f84ee775e3904a395.jpg";